import { useCallback, useEffect, useMemo, useState } from 'react';
import { ThemeContext, type Theme, type ThemeContextValue } from './ThemeContext';

function getInitialTheme(): Theme {
  const stored = localStorage.getItem('theme');
  if (stored === 'playful' || stored === 'grandmaster') return stored;
  return 'playful';
}

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const [theme, setThemeState] = useState<Theme>(() => getInitialTheme());

  const setTheme = useCallback((next: Theme) => {
    setThemeState(next);
    localStorage.setItem('theme', next);
    document.documentElement.setAttribute('data-theme', next);
  }, []);

  const toggleTheme = useCallback(() => {
    const next = theme === 'playful' ? 'grandmaster' : 'playful';
    setTheme(next);
  }, [theme, setTheme]);

  // Sync data-theme attribute on mount and when theme changes
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  const value = useMemo<ThemeContextValue>(
    () => ({ theme, setTheme, toggleTheme }),
    [theme, setTheme, toggleTheme],
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}
